import { render } from "./Payout.vue?vue&type=template&id=36641ebb"
import script from "./Payout.vue?vue&type=script&lang=js"
export * from "./Payout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__